import { render, staticRenderFns } from "./ImportExcelEmailDomain.vue?vue&type=template&id=8fe0ff68&scoped=true&"
import script from "./ImportExcelEmailDomain.vue?vue&type=script&lang=js&"
export * from "./ImportExcelEmailDomain.vue?vue&type=script&lang=js&"
import style0 from "./ImportExcelEmailDomain.vue?vue&type=style&index=0&id=8fe0ff68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe0ff68",
  null
  
)

export default component.exports